import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { cvApi, cvErr } from "@/lib/vendorApi";
import { inputCls } from "@/pages/partner/PartnerLoginPage";
import { MemoAssist } from "@/components/memo/MemoAssist";

const when = (t) => (t ? new Date(t).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");
const TextBox = ({ on, set, testid }) => (
  <label className="inline-flex items-center gap-2 text-xs text-white/60"><input type="checkbox" checked={on} onChange={(e) => set(e.target.checked)} data-testid={testid} /> Also text them</label>
);

const Thread = ({ m, onDone }) => {
  const [body, setBody] = useState("");
  const [txt, setTxt] = useState(true);
  const send = async () => {
    try { const r = await cvApi.post(`/memos/${m.id}/replies`, { body, send_text: txt }); toast.success(`Reply sent${r.sms_status === "sent" ? " · texted" : ""}`); setBody(""); setTxt(true); onDone(); } catch (e) { toast.error(cvErr(e)); }
  };
  return (
    <li className="rounded-lg border border-white/10 p-4 space-y-2" data-testid={`vendor-memo-${m.id}`}>
      <div className="flex justify-between gap-2"><b>{m.subject}</b><span className="text-xs text-white/40">{when(m.created_at)}</span></div>
      <p className="text-sm whitespace-pre-wrap text-white/80">{m.body}</p>
      {(m.replies || []).map((r) => (
        <div key={r.id} className={`pl-3 border-l text-sm ${r.by_kind === "resident" ? "border-emerald-400/50" : "border-[#d4a017]/40"}`}>
          <div className="text-xs text-white/40">{r.by_kind === "resident" ? "Worker" : r.by_kind === "vendor" ? "You" : "TEA staff"} · {r.author?.name} · {when(r.at)}</div>
          <div className="whitespace-pre-wrap">{r.body}</div>
        </div>
      ))}
      <textarea rows={3} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Reply…" data-testid={`vendor-memo-reply-${m.id}`} className={inputCls} />
      <MemoAssist value={body} onChange={setBody} id={`vendor-memo-reply-${m.id}`} />
      <div className="flex items-center justify-between"><TextBox on={txt} set={setTxt} testid={`vendor-memo-reply-text-${m.id}`} />
        <button type="button" disabled={!body.trim()} onClick={send} data-testid={`vendor-memo-reply-send-${m.id}`} className="rounded-md bg-[#d4a017] text-black text-sm font-semibold px-4 py-2 disabled:opacity-40">Send reply</button></div>
    </li>
  );
};

/** Memos to the workers this vendor hired — same Memo Board residents already use; a text goes out by default. */
export function MessagesTab({ workers, to }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ resident_id: to || "", subject: "", body: "", send_text: true });
  const load = () => cvApi.get("/memos").then((d) => setRows(d.memos)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => { if (to) setF((x) => ({ ...x, resident_id: to })); }, [to]);
  const send = async (e) => {
    e.preventDefault();
    try { const m = await cvApi.post("/memos", f); toast.success(`Memo sent${m.sms?.status === "sent" ? " · texted" : m.sms?.status === "no_phone" ? " · no mobile on file, not texted" : ""}`); setF({ ...f, subject: "", body: "" }); load(); }
    catch (err) { toast.error(cvErr(err)); }
  };
  return (
    <div className="space-y-5" data-testid="vendor-messages">
      <form onSubmit={send} className="space-y-3 rounded-lg border border-white/10 p-4">
        <select data-testid="vendor-memo-worker" value={f.resident_id} onChange={(e) => setF({ ...f, resident_id: e.target.value })} className={inputCls}>
          <option value="">To which worker?</option>{workers.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}</select>
        <input placeholder="Subject" data-testid="vendor-memo-subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} className={inputCls} />
        <textarea rows={4} placeholder="Message" data-testid="vendor-memo-body" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} className={inputCls} />
        <MemoAssist value={f.body} onChange={(v) => setF((x) => ({ ...x, body: v }))} id="vendor-memo-body" />
        <div className="flex items-center justify-between"><TextBox on={f.send_text} set={(v) => setF({ ...f, send_text: v })} testid="vendor-memo-text" />
          <button type="submit" disabled={!f.resident_id || !f.subject.trim() || !f.body.trim()} data-testid="vendor-memo-send" className="rounded-md bg-[#d4a017] text-black text-sm font-semibold px-4 py-2 disabled:opacity-40">Send memo</button></div>
      </form>
      <ul className="space-y-3" data-testid="vendor-memo-list">{rows.map((m) => <Thread key={m.id} m={m} onDone={load} />)}</ul>
      {!rows.length && <p className="text-sm text-white/40">No memos yet.</p>}
    </div>
  );
}
